<template>
  <div>
    <div v-if="this.loadingFormSubmit == true" class="loader">Loading...</div>
    
    <div v-if="this.loadingFormSubmit == false">
      <h1>this is the confirm email reset password page</h1>
      <el-form>
        <el-form-item>
          <el-input
            placeholder="New Password"
            prefix-icon="fas fa-lock"
            show-password="true"
            v-model="form.newpassword"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            placeholder="Repeat Password"
            prefix-icon="fas fa-lock"
            show-password="true"
            v-model="form.confirmpassword"
          ></el-input>
        </el-form-item>
        <el-form-item class="self-align">
          <el-button type="primary" @click.native="SubmitForm()" block>Change Password</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import EventService from "@/services/EventService.js";
export default {
  data() {
    return {
      form: {
        newpassword: "",
        confirmpassword: ""
      },
      loadingFormSubmit: false
    };
  },
  created() {},
  methods: {
    SubmitForm() {
       
      this.loadingFormSubmit = true; 

      EventService.ConfirmEmailFromPasswordReset(
        this.$route.query.userid,
        this.$route.query.token,
        this.form
      ).then(response => {
        if (response.status == 200) {
          this.$router.push({ name: "Login" });
        }
      })
      .catch(error => {
          console.log(error);
          this.loadingFormSubmit = false;
      });
    }
  }
};
</script>

<style>
</style>